import Home from "./pages/home/Home";
import Product from './pages/Product/Product';
import Search from './pages/search/search';
import Category from './pages/category/category';
import Ofertas from './pages/ofertas/ofertas';
import Combos from './pages/combos/combos';
import Cart from './pages/Cart/Cart';
import OrderHistory from './pages/orderHistory/orderHistory';
import EmailVerification from './pages/emailVerification/emailVerification';
import { ClienteProfilePage } from './pages/cliente/clienteProfileForm/clienteProfilePage';
import BuyOK from './pages/buyOk/buyok';
import OrderOK from './pages/buyOk/orderok';
import { ClienteFormPage } from './pages/cliente/clienteForm/clienteFormPage';
import { ClienteFavoritosPage } from './pages/cliente/clienteFavoritosTable/clienteFavoritosPage';
import { ClienteForgotPasswordPage } from './pages/cliente/clienteForgotPassword/clienteForgotPasswordPage';
import { PasswordResetResult } from "./pages/cliente/clienteForgotPassword/PasswordResetResult";
import { ClienteResetAccountPage } from "./pages/cliente/clienteResetAccount/clienteResetAccountPage";
import { ClienteResetFormPage } from "./pages/cliente/clienteResetForm/clienteResetFormPage";
import { ResetPassword } from "./pages/cliente/clienteForgotPassword/resetpassword";
import { ClienteChangePassword } from "./pages/cliente/clienteChangePassword/clienteChangePassword";
import { ClienteRegisterPage } from './pages/cliente/clienteFormRegister/clienteRegisterPage';
import Contacto from './pages/contacto/contacto';
import Footer from "./components/Footer/Footer";
import Navbar from "./components/navbar/Navbar";
import Login from "./pages/login/login";
import ThemeAdmin from "./pages/admin/ThemeAdmin";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./style/dark.scss";
import { DarkModeContext } from "./context/darkModeContext";
import { AuthProvider } from "./context/authContext";
import { ThemeProvider } from "./context/themeContext";
import { SnackbarProvider } from 'notistack';
import { SnackbarUtilsConfigurator } from './components/Toast';
import { Zoom } from '@mui/material';
import { HelmetProvider } from "react-helmet-async";
import useDocumentTitle from "./components/Title";
import { useContext,useEffect, useState } from "react";
import { getEmpresa } from "./services/EmpresaServices";

function App() {
  const { darkMode } = useContext(DarkModeContext);
  const [empresaData, setEmpresaData] = useState();
  const titleGrid = empresaData?.nombre_sitio
    ? `${empresaData.nombre_sitio} - Ecommerce`
    : "Ecommerce";


  useDocumentTitle(titleGrid);
  useEffect(() => {
    getEmpresaData();
  }, []);

  const getEmpresaData = async () => {
    try {
      if (!empresaData) {
        const empresaResponse = await getEmpresa();
        setEmpresaData(empresaResponse); 
        localStorage.setItem("panelempresaData", JSON.stringify(empresaResponse));
      }
    } catch (error) {
      console.error("Error al obtener los datos de la empresa:", error);
    }
  };

  return (
    <div className={darkMode ? "app dark" : "app"}>
      <SnackbarProvider TransitionComponent={Zoom} autoHideDuration={3000} maxSnack={2}>
        <SnackbarUtilsConfigurator />
        <HelmetProvider>
          <BrowserRouter basename="/ecommerce">
            <AuthProvider>
              <ThemeProvider>
                <div className="test">
                  <Routes>
                    <Route path="login" element={<Login />} />
                    <Route path="createAccount" element={<ClienteFormPage />} />
                    <Route path="forgotPassword" element={<ClienteForgotPasswordPage />} />
                    <Route path="password-reset-result" element={<PasswordResetResult />} />
                    <Route path="reset-password" element={<ResetPassword />} />
                    <Route path="reset-account" element={<ClienteResetAccountPage />} />
                    <Route path="validate-account" element={<ClienteResetFormPage />} />
                    <Route path="change-password" element={<ClienteChangePassword />} />
                    <Route path="account" element={<ClienteRegisterPage />} />
                    <Route
                      path="/*"
                      element={
                        <div className="listContainer">
                          <Navbar />
                          <Routes>
                            <Route path="/">
                              <Route index element={<Home />} />
                              <Route path='product/:productID' element={<Product />} />
                              <Route path='search' element={<Search />} />
                              <Route path='cart' element={<Cart />} />
                              <Route path='buyok' element={<BuyOK />} />
                              <Route path='orderok' element={<OrderOK />} />
                              <Route path='category' element={<Category />} />
                              <Route path='ofertas' element={<Ofertas />} />
                              <Route path='combos' element={<Combos />} />
                              <Route path='contacto' element={<Contacto />} />
                              <Route path='orderHistory' element={<OrderHistory />} />
                              <Route path='email-verification' element={<EmailVerification />} />
                              <Route path='favourites' element={<ClienteFavoritosPage />} />
                              <Route path='admin' element={<ThemeAdmin />} />

                              {/* ── Perfil con tab por URL ── */}
                              <Route path='profile' element={<ClienteProfilePage />} />
                              <Route path='profile/datos' element={<ClienteProfilePage defaultTab="dpersonales" />} />
                              <Route path='profile/pedidos' element={<ClienteProfilePage defaultTab="dpedidos" />} />
                              <Route path='profile/historial' element={<ClienteProfilePage defaultTab="dhistorial" />} />
                              <Route path='profile/envio' element={<ClienteProfilePage defaultTab="denvio" />} />
                              <Route path='profile/entrega' element={<ClienteProfilePage defaultTab="dentrega" />} />
                              <Route path='profile/contrasena' element={<ClienteProfilePage defaultTab="dacceso" />} />
                            </Route>
                          </Routes>
                          <Footer />
                        </div>
                      }
                    />
                  </Routes>
                </div>
              </ThemeProvider>
            </AuthProvider>
          </BrowserRouter>
        </HelmetProvider>
      </SnackbarProvider>
    </div>
  );
}

export default App;